'use client';

import Script from 'next/script';

import { getENV } from '../../../../utils/env';

export function OneTrustScript({ scriptId }: Readonly<{ scriptId: string | undefined }>) {
    const { NEXT_PUBLIC_ONETRUST_SCRIPT_US_URL, NEXT_PUBLIC_ONETRUST_SCRIPT_CA_URL, NEXT_PUBLIC_LOCALE } = getENV();
    const isCA = NEXT_PUBLIC_LOCALE === 'en-CA';
    const oneTrustScriptSrc = isCA ? NEXT_PUBLIC_ONETRUST_SCRIPT_CA_URL : NEXT_PUBLIC_ONETRUST_SCRIPT_US_URL;

    return (
        <Script
            id="OneTrust-Script"
            strategy="afterInteractive"
            /*
              If we set the strategy parameter [strategy=“beforeInteractive”], we will get this error
              >>> Error:
              Uncaught SyntaxError: Unexpected token '<', "<!DOCTYPE "... is not valid JSON...
             */
            src={oneTrustScriptSrc}
            data-domain-script={scriptId}
            data-testid="onetrust-script-test"
        />
    );
}
